import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import '@fontsource/nunito-sans';
import '@fontsource/poppins';
import './index.css';
import App from './App';
import { AuthProvider } from './provider/Auth.provider';
import { ConfigProvider, theme, App as AntdApp } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { darkAlgorithm } = theme;

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AntdApp>
        <ConfigProvider
          theme={{
            algorithm: darkAlgorithm,
            token: {
              colorBgBase: "#000",            // Main background
              colorTextBase: "#fff",          // Main text
              colorText: "#fff",
              colorTextSecondary: "#ddd",     // Secondary text
              colorTextPlaceholder: "#999",   // Placeholder
              colorPrimary: "#d49814",        // Button / link highlight
              colorBorder: "#555",            // Borders
              // colorBgContainer: "#0d0d0d",    // Elevated containers like Cards, Modals
              colorBgElevated: "#4e4e4e",     // Dropdowns, Popups, Toolt
            },
          }}
        >
          <App />
        </ConfigProvider>
      </AntdApp>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
